<template lang="pug">
  tr.item-row
    td {{ item[fields.DRIVING_SCHOOL] }}
    td {{ item[fields.SLUG] }}
    td {{ item[fields.DRIVING_SCHOOL_NUMBER] }}
    td {{ item[fields.COUNT] }}
    td {{ item[fields.PAID] }}
    td {{ item[fields.PCT_FROM_TOTAL_COUNT] }}
    td {{ item[fields.PCT_FROM_TOTAL_PAID] }}
    td 
      driving-school-edit(:item="item" @update="updateItem")
        template(v-slot="edit")
          v-dialog(
            max-width="400px"
            :value="edit.showing"
            @input="edit.updateShowing"
          )
            template(v-slot:activator="{on}")
              v-btn(icon color="primary"  @click="edit.toggle")
                v-icon mdi-pencil
            v-card
              v-card-title Edit driving school
              v-divider
              v-card-text
                driving-school-body(
                  :formData="edit.formData"
                  :formErrors="edit.formErrors"
                  @update="edit.updateFormData"
                )
              v-divider
              v-card-actions
                v-spacer
                v-btn(@click="edit.toggle" color="primary" outlined ) cancel
                v-btn(@click="edit.checkValidatorBeforeSend(edit.formData)"  color="primary") Update
      
      
      driving-school-remove(:id="item.id" @remove="$emit('remove', $event)" :key="item.id")
        template(v-slot="remove")
          v-btn(icon color="error" @click="remove.toggle" :disabled="item.paid === '0.00' ? false: true")
            v-icon mdi-delete
            confirmation-dialog(
              :value="remove.showing"
              @input="remove.updateShowing"
              @okBtnClicked="remove.send"
              @failBtnClicked="remove.toggle"
              title="Removing driving school"
              descr="Are you sure you want to remove driving school?"
              okText="ok"
              failText="cancel"
            )

</template>

<script>
import { fields } from '../core/const'
import DrivingSchoolEdit from "./DrivingSchoolEdit.vue"
import DrivingSchoolBody from "./DrivingSchoolBody.vue"
import DrivingSchoolRemove from './DrivingSchoolRemove.vue'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    fields
  }),

  methods: {
    updateItem(data) {
      for(let field in data) {
        this.item[field] = data[field]
      }
    },
  },

  components: {
    DrivingSchoolEdit,
    DrivingSchoolBody,
    DrivingSchoolRemove,
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue'),

  }
}
</script>

<style lang="scss" scoped>

  .item-row{
    td {
      border-right: 1px solid $border-color;
      border-bottom :1px solid $border-color;
      text-align: center;

      &:last-of-type{
        border-right: none;
      }
    }
  }

</style>